import { FC } from 'react';

import { FontAwesomeIcon, If } from '@hsp/react-component-library';

import { INotificationEmptyProps } from 'types/components/notifications/center';
import { s } from 'utilities/strings';

import cssClasses from './notification-empty.module.scss';

const NotificationEmpty: FC<INotificationEmptyProps> = ({ show }) => {
  return (
    <If condition={show}>
      <div className={cssClasses.notificationEmpty}>
        <div className="mb-3">
          <FontAwesomeIcon
            icon={['fas', 'bell']}
            size="10x"
          />
        </div>
        <h5>{s('Site.NotificationCenter.Empty')}</h5>
      </div>
    </If>
  );
};

export default NotificationEmpty;
